import {
  Box,
  Text,
  VStack,
  HStack,
  NumberInput,
  NumberInputField,
  Checkbox,
} from '@chakra-ui/react';

import { ValidatedField } from '..';
import type { CoverageSectionProps } from './types';

const IncludedPerilAdjustmentsSection = ({
  coverages,
  updateCoverage,
}: CoverageSectionProps) => {
  return (
    <Box>
      <Text fontWeight="700" mb={3}>
        Included Peril Adjustments
      </Text>
      <VStack align="stretch" spacing={2}>
        <HStack spacing={3} align="flex-end">
          <Checkbox
            isChecked={coverages.hail_peril_adjustment_enabled}
            onChange={(e) =>
              updateCoverage('hail_peril_adjustment_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Hail</Text>
          </Checkbox>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.hail_peril_adjustment_limit_cad"
            label="Limit"
            labelSize="xs"
            formControlProps={{ w: '90px' }}
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.hail_peril_adjustment_limit_cad ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'hail_peril_adjustment_limit_cad',
                  valueString ? Number(valueString) : null,
                )
              }
              isDisabled={!coverages.hail_peril_adjustment_enabled}
            >
              <NumberInputField
                height={30}
                placeholder={
                  coverages.hail_peril_adjustment_enabled ? 'BASE' : ''
                }
              />
            </NumberInput>
          </ValidatedField>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.hail_peril_adjustment_deductible_cad"
            label="Deductible"
            labelSize="xs"
            formControlProps={{ w: '90px' }}
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.hail_peril_adjustment_deductible_cad ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'hail_peril_adjustment_deductible_cad',
                  valueString ? Number(valueString) : null,
                )
              }
              isDisabled={!coverages.hail_peril_adjustment_enabled}
            >
              <NumberInputField
                height={30}
                placeholder={
                  coverages.hail_peril_adjustment_enabled ? 'BASE' : ''
                }
              />
            </NumberInput>
          </ValidatedField>
        </HStack>
        <HStack spacing={3} align="flex-end">
          <Checkbox
            isChecked={coverages.wind_peril_adjustment_enabled}
            onChange={(e) =>
              updateCoverage('wind_peril_adjustment_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Wind</Text>
          </Checkbox>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.wind_peril_adjustment_limit_cad"
            label="Limit"
            labelSize="xs"
            formControlProps={{ w: '90px' }}
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.wind_peril_adjustment_limit_cad ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'wind_peril_adjustment_limit_cad',
                  valueString ? Number(valueString) : null,
                )
              }
              isDisabled={!coverages.wind_peril_adjustment_enabled}
            >
              <NumberInputField
                height={30}
                placeholder={
                  coverages.wind_peril_adjustment_enabled ? 'BASE' : ''
                }
              />
            </NumberInput>
          </ValidatedField>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.wind_peril_adjustment_deductible_cad"
            label="Deductible"
            labelSize="xs"
            formControlProps={{ w: '90px' }}
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.wind_peril_adjustment_deductible_cad ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'wind_peril_adjustment_deductible_cad',
                  valueString ? Number(valueString) : null,
                )
              }
              isDisabled={!coverages.wind_peril_adjustment_enabled}
            >
              <NumberInputField
                height={30}
                placeholder={
                  coverages.wind_peril_adjustment_enabled ? 'BASE' : ''
                }
              />
            </NumberInput>
          </ValidatedField>
        </HStack>
        <HStack spacing={3} align="flex-end">
          <Checkbox
            isChecked={coverages.water_peril_adjustment_enabled}
            onChange={(e) =>
              updateCoverage('water_peril_adjustment_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Water</Text>
          </Checkbox>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.water_peril_adjustment_limit_cad"
            label="Limit"
            labelSize="xs"
            formControlProps={{ w: '90px' }}
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.water_peril_adjustment_limit_cad ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'water_peril_adjustment_limit_cad',
                  valueString ? Number(valueString) : null,
                )
              }
              isDisabled={!coverages.water_peril_adjustment_enabled}
            >
              <NumberInputField
                height={30}
                placeholder={
                  coverages.water_peril_adjustment_enabled ? 'BASE' : ''
                }
              />
            </NumberInput>
          </ValidatedField>
          <ValidatedField
            itemPath="location"
            fieldPath="coverages.water_peril_adjustment_deductible_cad"
            label="Deductible"
            labelSize="xs"
            formControlProps={{ w: '90px' }}
          >
            <NumberInput
              variant="main"
              size="sm"
              min={0}
              value={coverages.water_peril_adjustment_deductible_cad ?? ''}
              onChange={(valueString) =>
                updateCoverage(
                  'water_peril_adjustment_deductible_cad',
                  valueString ? Number(valueString) : null,
                )
              }
              isDisabled={!coverages.water_peril_adjustment_enabled}
            >
              <NumberInputField
                height={30}
                placeholder={
                  coverages.water_peril_adjustment_enabled ? 'BASE' : ''
                }
              />
            </NumberInput>
          </ValidatedField>
        </HStack>
      </VStack>
    </Box>
  );
};

export default IncludedPerilAdjustmentsSection;
